import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {SystemInfo} from '@/model/system/SystemInfo';
import {SoftwareDetails} from '@/model/system/SoftwareDetails';
import {OsInfo} from '@/model/system/OsInfo';
import {HardwareInfo} from '@/model/system/HardwareInfo';

import {ISystemInfoService} from '@/services/system/IInfo.service';
import {ISystemOsService} from '@/services/system/IOs.service';
import {ISystemHardwareService} from '@/services/system/IHardware.service';

@Module({name: 'SystemInfoStore', namespaced: true})
export default class SystemInfoStore extends VuexModule {

  private systemInfo: SystemInfo | null = null;
  private osInfo: OsInfo | null = null;
  private hardwareInfo: HardwareInfo | null = null;
  private softwareDetails: SoftwareDetails[] | null = null;

  @Inject(Symbol.for('ISystemInfoService'))
  private systemService!: ISystemInfoService;

  @Inject(Symbol.for('ISystemOsService'))
  private osService!: ISystemOsService;

  @Inject(Symbol.for('ISystemHardwareService'))
  private hardwareService!: ISystemHardwareService;

  @Action({commit: 'setSystemInfo', rawError: true})
  public async fetchSystemInfo() {
    return await this.systemService.getInfo();
  }

  @Mutation
  public setSystemInfo(info: SystemInfo) {
    this.systemInfo = info;
  }

  get SystemInfo() {
    return this.systemInfo;
  }


  @Action({commit: 'setSoftwareDetails', rawError: true})
  public async fetchSoftwareDetails() {
    return await this.systemService.getSoftwareDetails();
  }

  @Mutation
  public setSoftwareDetails(softwareDetails: SoftwareDetails[]) {
    this.softwareDetails = softwareDetails;
  }

  get SoftwareDetails() {
    return this.softwareDetails;
  }


  @Action({commit: 'setOsInfo', rawError: true})
  public async fetchOsInfo() {
    return await this.osService.getInfo();
  }

  @Mutation
  public setOsInfo(info: OsInfo) {
    this.osInfo = info;
  }

  get OsInfo() {
    return this.osInfo;
  }


  @Action({commit: 'setHardwareInfo', rawError: true})
  public async fetchHardwareInfo() {
    return await this.hardwareService.getInfo();
  }

  @Mutation
  public setHardwareInfo(info: HardwareInfo) {
    this.hardwareInfo = info;
  }

  get HardwareInfo() {
    return this.hardwareInfo;
  }
}
